import { render, staticRenderFns } from "./ModalEdicioUsuari.vue?vue&type=template&id=6203cd1f&"
import script from "./ModalEdicioUsuari.vue?vue&type=script&lang=js&"
export * from "./ModalEdicioUsuari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports